import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import QuillEditor from 'react-quill';

export default function QuillRichText({ value, onChange, defaultValue }) {
  const quill = useRef();
  const modules = useMemo(
    () => ({
      toolbar: {
        container: [
          [{ header: [2, 3, 4, false] }],
          ['bold', 'italic', 'underline', 'blockquote'],
          [{ color: [] }],
          [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
          ['link', 'image']['clean']
        ]
        // handlers: {
        //   image: imageHandler
        // }
      },
      clipboard: {
        matchVisual: true
      }
    }),
    []
  );

  const formats = [
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'indent',
    'link',
    'image',
    'color',
    'clean'
  ];
  return (
    <QuillEditor
      ref={(el) => (quill.current = el)}
      defaultValue={defaultValue}
      theme="snow"
      value={value}
      formats={formats}
      modules={modules}
      onChange={onChange}
    />
  );
}
